<div>
    <a class="dropdown-item" (click)="manage()">
        <span class='glyphicon glyphicon-log-in'></span> {{userName}}
    </a>
</div>
<div>
    <a class="dropdown-item" (click)="signOut()">
        <span class='glyphicon glyphicon-log-out'></span> Sign Out
    </a>
</div>